export const REPORT_DATE_RANGE = 365;
